export default __webpack_public_path__ + "static/media/jsLogo.ab65e723.png";